<template>
    <settings-wrapper title="Organization settings" section="General">
        <v-alert type="info" text dense>Features enabled here will be available for all spaces created in this organization.</v-alert>
        <v-row>
            <v-col v-for="(feature, index) in features" :key="index" cols="3">
                <org-feature-status :feature="feature" />
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <h3 class="error--text">Danger Zone</h3>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="6">
                <v-card>
                    <v-card-title>Leave organization</v-card-title>
                    <v-card-actions>
                        <EntityLeaveDialog entity-type="organization" />
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </settings-wrapper>
</template>

<script>
import eventBus from '@/components/EventBus'
import OrgFeatureStatus from '@/components/OrgFeatureStatus.vue'
import { mapState } from 'vuex'
import SettingsWrapper from '@/components/SettingsWrapper.vue'
import EntityLeaveDialog from '@/components/EntityLeaveDialog.vue'

const featureProperties = {
    loading: false,
    enabled: false,
    canEnable: false,
    disabledReason: '',
    error: '',
    fn: () => {}
}

export default {
    name: 'OrganizationConfig',
    components: { OrgFeatureStatus, EntityLeaveDialog, SettingsWrapper },
    computed: {
        ...mapState(['currentOrgData'])
    },
    data() {
        return {
            switchingFeature: '',
            features: {
                vimeo: {
                    ...featureProperties,
                    label: 'Video library',
                    description: 'Upload videos to make your content more interactive on Nuvolos.'
                },
                hpc: {
                    ...featureProperties,
                    label: 'Credit-based sizes',
                    description: 'Scale up your application resources using credits.'
                },
                tables: {
                    ...featureProperties,
                    label: 'Database tables',
                    description: 'Use the Scientific Data Warehouse to work with massive amounts of tabular data.'
                }
                // switch: {
                //     ...featureProperties,
                //     label: 'Switch Cloud integration',
                //     description: 'Enable Switch Cloud resources for spaces in this organization.'
                // }
            }
        }
    },
    created() {
        eventBus.$on('global-dialog-accept', this.enableFeature)
        Object.keys(this.features).forEach(this.fetchStatusOfFeature)
    },
    beforeDestroy() {
        eventBus.$off('global-dialog-accept')
    },
    methods: {
        setSwitchDemoEnabled(enabled) {
            return false
        },
        confirmFeatureSwitch(feature) {
            return async newState => {
                this.switchingFeature = feature
                const dialogTitle = `${newState ? 'Enabling' : 'Disabling'} ${this.features[feature].label}`
                const dialogText =
                    feature === 'switch'
                        ? newState
                            ? `Once Switch Cloud integration is enabled, Space Administrators will be able to enable Switch Cloud resources in their spaces individually.`
                            : `By turning off Switch Cloud integration, Space Administrators won't be able to enable Switch Cloud resources in additional spaces. Spaces that already have it enabled will remain enabled.`
                        : newState
                        ? `Once this feature is enabled, Space Administrators will be able to enable it in their spaces individually.`
                        : `By turning off this feature, Space Administrators won't be able to change their space's feature flag anymore. This means, spaces which already have this feature enabled will remain enabled, but the feature cannot be enabled anymore for other spaces.`
                this.$store.dispatch('showGlobalDialog', {
                    dialogTitle,
                    dialogText,
                    dialogAction: ['cancel', 'accept']
                })
            }
        },
        async enableFeature() {
            const feature = this.switchingFeature
            if (!feature) return
            const { oid } = this.$route.params
            const f = this.features[feature]
            f.loading = true

            if (feature === 'switch') {
                this.setSwitchDemoEnabled(!f.enabled)
                f.enabled = this.getSwitchDemoEnabled()
                f.loading = false
                return
            }

            try {
                const { data } = await this.$axios.patch(`orgs/${oid}`, {
                    [`${feature}_enabled`]: !f.enabled
                })
                f.loading = false
                this.$store.commit('setCurrentOrgData', data)
            } catch (error) {
                console.error(error)
                this.$store.dispatch('showSnackBar', {
                    snackBarText: `Failed to ${this.features[feature].enabled ? 'disable' : 'enable'} ${this.features[
                        feature
                    ].label.toLowerCase()}, please try again later!`,
                    snackBarTimeout: 5000,
                    snackBarIcon: 'error'
                })
                f.loading = false
            }
        },
        fetchStatusOfFeature(feature) {
            const f = this.features[feature]
            f.loading = true
            f.fn = this.confirmFeatureSwitch(feature)

            if (feature === 'switch') {
                f.enabled = this.getSwitchDemoEnabled()
                f.canEnable = true
                f.disabledReason = ''
                f.error = ''
                f.loading = false
                return
            }

            this.$axios
                .get(`/orgs/${this.$route.params.oid}/can_enable_${feature}`)
                .then(({ data }) => {
                    if (this.currentOrgData) f.enabled = this.currentOrgData[`${feature}_enabled`]
                    f.canEnable = data[`can_enable_${feature}`]
                    f.disabledReason = data.reason
                    f.loading = false
                })
                .catch(error => {
                    f.loading = false
                    f.error = error.message
                })
        }
    },
    watch: {
        currentOrgData(org) {
            for (const feature in this.features) {
                if (feature === 'switch') continue
                this.features[feature].enabled = org[`${feature}_enabled`]
            }
        }
    }
}
</script>
